module.exports = __webpack_public_path__ + "img/oval.db71061c.png";